import React from 'react';
import { apiGetReunionList, apiIsLoggedIn } from '../../../api/api';
import { Link } from 'react-router-dom';

class ReunionTimeline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reunions: [],
        }
    }

    componentDidMount() {
        apiIsLoggedIn().then(isLoggedIn => {
            if (!isLoggedIn) {
                window.location.href = '/';
            }
        }).catch(error => {
            console.error('Error checking login status:', error);
            window.location.href = '/';
        });

        apiGetReunionList().then(response => {
            if (response.ok) {
                response.json().then(data => {
                    this.setState({
                        reunions: data.reunions,
                    });
                }).catch(error => {
                    console.error('Error parsing reunion list: ', error);
                });
            } else {
                throw new Error('Failed to fetch reunion list')
            }
        })
    }

    render() {
        let reunionDivs = [];

        const sortedReunions = [...this.state.reunions].sort((a, b) => b.Year - a.Year);
        for (let i = 0; i < sortedReunions.length; i++) {
            let reunion = sortedReunions[i];

            let containerClass = "container left"
            if (i % 2 === 1) {
                containerClass = "container right"
            }

            reunionDivs.push(
                <div className={containerClass} key={reunion.Year}>
                    <div className="content">
                        <h2><Link to={`/reunion/${reunion.Year}`}>{reunion.Year}: {reunion.City}, {reunion.Country}</Link></h2>
                    </div>
                </div>
            )
        }

        return (
            <div className="timeline">
                {reunionDivs}
            </div>
        );
    }
}

export default ReunionTimeline;
